import { useEffect } from "react";
import { useFormContext } from "react-hook-form";

const CustomDataSection = ({
  customFields,
  errors,
}) => {

  const { register, getValues } = useFormContext();

  if (!customFields.length) {
    return (
      <div className="mt-4 p-4 rounded text-center">
          <h3 className="text-sm font-semibold mb-2">No Custom Fields</h3>
      </div>
    );
  }

  return (
    <div className="mt-4 p-4 rounded">
      {customFields.map((field, idx) => {
        let inputType = "text";
        if (field.field_type === "Number") inputType = "number";
        else if (field.field_type === "Date") inputType = "date";
        else if (field.field_type === "Time") inputType = "time";
        else if (field.field_type === "Datetime") inputType = "datetime-local";
        return (
          <div key={field.id} className="flex gap-2 items-center mb-2">
            <label className="text-sm w-40">
              {field.name} {field.mandatory && <span className="text-red-500">*</span>}
            </label>
            <input
              key={field.id}
              {...register(`custom_fields.${idx}.value`, {
                // required: field.mandatory ? `${field.name} is required` : false
                required: false
              })}
              type={inputType}
              className="border rounded p-1 text-sm flex-1"
            />
          </div>
        )})}
    </div>
  );
};

export default CustomDataSection;
